const w: any = window;

const envVars = {
  PUBLIC_URL: w.ENV_PUBLIC_URL || import.meta.env.BASE_URL,
  REACT_APP_RECAPTCHA_KEY:
    w.ENV_REACT_APP_RECAPTCHA_KEY || import.meta.env.REACT_APP_RECAPTCHA_KEY,
  REACT_APP_STAND_ALONE_MODE:
    w.ENV_REACT_APP_STAND_ALONE_MODE ||
    import.meta.env.REACT_APP_STAND_ALONE_MODE,
  REACT_APP_API_URL:
    w.ENV_REACT_APP_API_URL || import.meta.env.REACT_APP_API_URL,
  REACT_APP_RECAPTCHA_KEY_v2:
    w.ENV_REACT_APP_RECAPTCHA_KEY_v2 ||
    import.meta.env.REACT_APP_RECAPTCHA_KEY_v2,
  REACT_APP_NODE_ENV:
    w.ENV_REACT_APP_NODE_ENV || import.meta.env.REACT_APP_NODE_ENV,
  REACT_APP_HOST_URL_IMAGE:
    w.ENV_REACT_APP_HOST_URL_IMAGE || import.meta.env.REACT_APP_HOST_URL_IMAGE,
};

export default envVars;
